import React from 'react'
import clsx from 'clsx'

interface ToolbarButtonProps {
  // React node so we can pass Lucide SVG icons. Strings still render fine.
  icon: React.ReactNode
  onClick: () => void
  active?: boolean
  disabled?: boolean
  title: string // acts as both tooltip and aria-label
}

export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  icon,
  onClick,
  active = false,
  disabled = false,
  title,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
      aria-pressed={active}
      className={clsx(
        // Base sizing + layout
        // h-toolbar-btn is defined in tailwind config (44px); w-toolbar-btn is not, use fixed fallback
        'flex h-toolbar-btn w-[44px] items-center justify-center',
        'text-lg select-none transition-colors duration-100',
        // Rounded hit area
        'rounded-md',
        // State-dependent styling
        !active && !disabled && 'text-sidebarIcon hover:bg-surfaceLight hover:text-textPrimary',
        active && 'bg-sidebarActive text-sidebarIconActive',
        disabled && 'cursor-not-allowed text-textDisabled',
      )}
    >
      <span aria-hidden="true">{icon}</span>
    </button>
  )
}
